import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AgoraService } from '../../services/agora.service';
import { Stream, isStreamPaid } from '../../models/stream.model';
import { getCurrentUserId } from '../../helpers/utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentModalComponent } from '../payment-modal/payment-modal.component';
import { LivePaymentService } from '../../services/live-payment.service';
import { NotificationService } from '../../services/notification.service';
import { formatStreamElapsed } from '../../helpers/utils';

@Component({
  selector: 'app-stream-list',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="stream-list-container">
      <div class="stream-header">
        <div class="header-left">
          <button class="back-btn" (click)="goBack()">
            <i class="fas fa-arrow-left"></i>
            <span class="hide-mobile">Retour à l'accueil</span>
          </button>
          <h2>Streams en direct</h2>
        </div>
        <div class="stream-filters">
          <!-- <button class="filter-btn active">Tous</button> -->
          <!-- <button class="filter-btn">Populaires</button>
          <button class="filter-btn">Nouveaux</button> -->
        </div>
      </div>
      
      <div class="streams-grid">
        <div *ngIf="isLoading" class="loader-container">
          <div class="loader"></div>
          <p>Chargement des streams...</p>
        </div>

        <div *ngIf="!isLoading && streams.length === 0" class="no-streams">
          <div class="no-streams-icon" aria-hidden="true">
            <i class="fa-solid fa-video-slash"></i>
          </div>
          <p>Aucun stream en direct pour le moment.</p>
          <button type="button" class="refresh-btn" (click)="loadStreams()">
            <i class="fa-solid fa-arrows-rotate" aria-hidden="true"></i>
            Actualiser
          </button>
        </div>

        <div *ngFor="let stream of streams" class="stream-card" (click)="watchStream(stream)">
          <div class="stream-thumbnail">
            <img [src]="stream.thumbnail_url || stream.user?.profile_picture || 'assets/user-default.png'" 
                 alt="Miniature du stream"
                 class="stream-image">
            <div class="stream-overlay">
              <div class="live-badge" *ngIf="stream.is_public">
                <span class="pulse"></span>
                EN DIRECT
                <span class="live-elapsed" *ngIf="streamElapsed(stream)">{{ streamElapsed(stream) }}</span>
              </div>
              <div class="stream-type-badges">
                <span class="badge-pill badge-paid" *ngIf="isStreamPaid(stream)">
                  <i class="fas fa-tag"></i>
                  <span>{{ stream.price }} USD</span>
                </span>
                <span class="badge-pill badge-free" *ngIf="!isStreamPaid(stream)">
                  <i class="fas fa-gift"></i>
                  <span>Gratuit</span>
                </span>
              </div>
              <div class="viewer-count">
                <i class="fas fa-eye"></i> {{ stream.viewer_count }}
              </div>
            </div>
          </div>
          
          <div class="stream-info">
            <div class="stream-title">
              <div class="stream-title-row">
                <h3>{{ stream.title }}</h3>
                <span class="badge-inline badge-paid" *ngIf="isStreamPaid(stream)">
                  <i class="fas fa-tag"></i> {{ stream.price }} USD
                </span>
                <span class="badge-inline badge-free" *ngIf="!isStreamPaid(stream)">
                  <i class="fas fa-gift"></i> Gratuit
                </span>
              </div>
              <div class="stream-meta">
                <span class="start-time">
                  <i class="far fa-clock"></i> {{ stream.created_at | date:'short' }}
                </span>
              </div>
            </div>
            <p class="stream-description">{{ stream.description }}</p>
            <div class="stream-footer">
              <button class="watch-btn">
                <i class="fas fa-play"></i> Regarder
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .stream-list-container {
      padding: 30px;
      max-width: 1400px;
      margin: 0 auto;
    }
    
    .stream-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
    }
    
    .stream-header h2 {
      font-size: 28px;
      font-weight: 700;
      color: #333;
      margin: 0;
    }
    
    .stream-filters {
      display: flex;
      gap: 10px;
    }
    
    .filter-btn {
      background: #f5f5f5;
      border: none;
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.3s ease;
    }
    
    .filter-btn:hover, .filter-btn.active {
      background: #dc3545;
      color: white;
    }
    
    .streams-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 25px;
    }
    
    .stream-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.08);
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 2px solid transparent;
    }
    
    .stream-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 20px rgba(0,0,0,0.12);
      border-color: #dc3545;
    }
    
    .stream-thumbnail {
      position: relative;
      width: 100%;
      aspect-ratio: 16/9;
      background: #f0f0f0;
      overflow: hidden;
    }
    
    .stream-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;
    }
    
    .stream-card:hover .stream-image {
      transform: scale(1.05);
    }
    
    .stream-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.6) 100%);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 15px;
    }
    
    .live-badge {
      position: absolute;
      top: 10px;
      left: 10px;
      background: #dc3545;
      color: white;
      padding: 6px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 5px;
    }
    .live-elapsed {
      margin-left: 6px;
      font-weight: 700;
      letter-spacing: 0.03em;
      font-variant-numeric: tabular-nums;
    }
    .stream-type-badges {
      position: absolute;
      top: 10px;
      right: 10px;
      display: flex;
      gap: 8px;
    }
    .badge-pill {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 6px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.02em;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      white-space: nowrap;
    }
    .badge-pill i {
      font-size: 11px;
      opacity: 0.95;
    }
    .badge-paid {
      background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
      color: white;
      border: 1px solid rgba(255,255,255,0.25);
    }
    .badge-free {
      background: linear-gradient(135deg, #198754 0%, #157347 100%);
      color: white;
      border: 1px solid rgba(255,255,255,0.25);
    }
    .stream-title-row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
      margin-bottom: 6px;
    }
    .stream-title-row h3 {
      margin: 0;
    }
    .badge-inline {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      padding: 4px 10px;
      border-radius: 14px;
      font-size: 11px;
      font-weight: 600;
    }
    .badge-inline.badge-paid {
      background: rgba(13, 110, 253, 0.12);
      color: #0d6efd;
    }
    .badge-inline.badge-free {
      background: rgba(25, 135, 84, 0.12);
      color: #198754;
    }
    
    .pulse {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: white;
      animation: pulse 1.5s infinite;
    }
    
    @keyframes pulse {
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
      }
      70% {
        transform: scale(1);
        box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);
      }
      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
      }
    }
    
    .viewer-count {
      position: absolute;
      bottom: 10px;
      right: 10px;
      background: rgba(0,0,0,0.7);
      color: white;
      padding: 6px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 5px;
    }
    
    .stream-info {
      padding: 20px;
    }
    
    .stream-title {
      margin-bottom: 10px;
    }
    
    .stream-title h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      line-height: 1.4;
    }
    
    .stream-meta {
      display: flex;
      align-items: center;
      gap: 15px;
      font-size: 13px;
      color: #666;
    }
    
    .start-time {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    
    .stream-description {
      font-size: 14px;
      color: #666;
      margin: 0 0 15px 0;
      line-height: 1.5;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    
    .stream-footer {
      display: flex;
      justify-content: flex-end;
    }
    
    .watch-btn {
      background: #dc3545;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
      transition: all 0.3s ease;
    }
    
    .watch-btn:hover {
      background: #c82333;
      transform: translateY(-2px);
    }
    
    .no-streams {
      grid-column: 1 / -1;
      text-align: center;
      padding: 40px 24px;
      background: #f8f9fa;
      border-radius: 12px;
      color: #6c757d;
    }

    .no-streams-icon {
      margin-bottom: 12px;
    }

    .no-streams-icon i {
      font-size: 32px;
      color: #dc3545;
      line-height: 1;
    }
    
    .no-streams p {
      font-size: 15px;
      margin: 0 0 14px;
    }

    .refresh-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      width: auto;
      padding: 6px 14px;
      font-size: 13px;
      line-height: 1.4;
      background: #FF4D67;
      color: white;
      border: none;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.2s ease;
    }

    .refresh-btn i {
      font-size: 12px;
      line-height: 1;
    }

    .refresh-btn:hover {
      background: #e0435a;
    }
    
    @media (max-width: 768px) {
      .stream-list-container {
        padding: 20px;
      }
      
      .stream-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
      }
      
      .stream-filters {
        width: 100%;
        overflow-x: auto;
        padding-bottom: 5px;
      }
      
      .streams-grid {
        grid-template-columns: 1fr;
      }
    }
    
    .header-left {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    
    .back-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      background: none;
      border: none;
      color: #dc3545;
      font-size: 14px;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 20px;
      transition: all 0.3s ease;
      border: 1px solid #dc3545;
    }
    
    .back-btn:hover {
      background: rgba(220, 53, 69, 0.1);
    }
    
    .back-btn i {
      font-size: 16px;
    }

    .loader-container {
      grid-column: 1 / -1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px;
      background: #f8f9fa;
      border-radius: 12px;
    }

    .loader {
      width: 48px;
      height: 48px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid #dc3545;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 16px;
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .loader-container p {
      color: #dc3545;
      font-size: 16px;
      margin: 0;
    }

    @media (max-width: 576px) {
      .hide-mobile {
        display: none;
      }
    }
  `]
})
export class StreamListComponent implements OnInit, OnDestroy {
  streams: Stream[] = [];
  isLoading = true;
  /** Rafraîchit l’affichage du chronomètre chaque seconde (aligné mobile). */
  private elapsedTick = 0;
  private elapsedIntervalId: ReturnType<typeof setInterval> | undefined;

  constructor(
    private agoraService: AgoraService,
    private router: Router,
    private modalService: NgbModal,
    private livePaymentService: LivePaymentService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.loadStreams();
    this.elapsedIntervalId = setInterval(() => {
      this.elapsedTick = Date.now();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.elapsedIntervalId != null) {
      clearInterval(this.elapsedIntervalId);
    }
  }

  streamElapsed(stream: Stream): string {
    void this.elapsedTick;
    return formatStreamElapsed(stream.started_at);
  }

  loadStreams() {
    this.isLoading = true;
    this.agoraService.getStreams().subscribe({
      next: (streams) => {
        this.streams = streams.filter((s) => s.status === 'live');
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des streams:', error);
        this.isLoading = false;
      }
    });
  }

  private isOwner(stream: Stream): boolean {
    const uid = getCurrentUserId();
    if (!uid || !stream.user_id) return false;
    return String(stream.user_id) === String(uid);
  }

  watchStream(stream: Stream) {
    const slug = stream.slug;
    if (!slug) return;

    const goToView = () => {
      this.agoraService.joinStream(slug).subscribe({
        next: () => this.router.navigate(['/stream', stream.slug, 'view']),
        error: () => this.router.navigate(['/stream', stream.slug, 'view'])
      });
    };

    if (!isStreamPaid(stream) || this.isOwner(stream)) {
      goToView();
      return;
    }

    this.agoraService.hasPaidForStream(slug).subscribe({
      next: (res) => {
        if (res.has_paid) {
          goToView();
          return;
        }
        this.openLivePaymentModal(stream);
      },
      error: () => {
        this.notificationService.error('Impossible de vérifier l\'accès au live.');
      }
    });
  }

  private openLivePaymentModal(stream: Stream) {
    const amount = stream.price ?? 0;
    if (amount <= 0) {
      this.agoraService.joinStream(stream.slug).subscribe({
        next: () => this.router.navigate(['/stream', stream.slug, 'view']),
        error: () => this.router.navigate(['/stream', stream.slug, 'view'])
      });
      return;
    }
    const reference = `LIVE-${Date.now()}-${Math.floor(Math.random() * 999999)}`;
    this.livePaymentService.createStreamPayment({
      stream_id: stream.id,
      amount,
      currency: 'USD',
      reference,
      type_payment_id: 2,
      source: 'web'
    }).subscribe({
      next: (res) => {
        const ref = res.data?.reference ?? reference;
        const modalRef = this.modalService.open(PaymentModalComponent, {
          size: 'md',
          centered: true,
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.amount = amount;
        modalRef.componentInstance.currency = 'USD';
        modalRef.componentInstance.reference = ref;
        modalRef.componentInstance.transactionId = ref;
        modalRef.componentInstance.isLivePayment = true;
        modalRef.componentInstance.streamSlug = stream.slug;
        modalRef.result.then(
          (result) => {
            if (result?.success) {
              this.notificationService.success('Paiement réussi. Vous pouvez accéder au live.');
              this.agoraService.joinStream(stream.slug).subscribe({
                next: () => this.router.navigate(['/stream', stream.slug, 'view']),
                error: () => this.router.navigate(['/stream', stream.slug, 'view'])
              });
            }
          },
          () => {}
        ).catch(() => {});
      },
      error: () => {
        this.notificationService.error('Impossible de charger les données de paiement.');
      }
    });
  }

  goBack() {
    this.router.navigate(['/']);
  }

  isStreamPaid(stream: Stream): boolean {
    return isStreamPaid(stream);
  }
} 